import { IconType } from 'common-types';
import {
  FilterType,
  FilterTypeSearch,
  FilterTypeToFilter,
} from '../../common/filters-utils/filters-utils';
import {
  ArtifactInfoTypes,
  CICDSystems,
  CloudSubType,
  CodeArtifactSCMTypes,
  RegistryTypes,
} from '../types/artifacts-type';
import { ReactComponent as ContainerIcon } from '../../assets/icons/containers-icon.svg';
import { ReactComponent as LambdaIcon } from '../../assets/icons/lambda-icon.svg';
import { ReactComponent as NPMIcon } from '../../assets/icons/npm-logo.svg';
import { ReactComponent as YarnIcon } from '../../assets/icons/yarn-logo.svg';
import { ReactComponent as GitlabIcon } from '../../assets/icons/gitlab-icon.svg';
import { ReactComponent as GithubIcon } from '../../assets/icons/github-icon.svg';
import { ReactComponent as AzureIcon } from '../../assets/icons/azure-icon.svg';
import { ReactComponent as BitbucketstashIcon } from '../../assets/icons/bitBucket-icon.svg';
import { ReactComponent as BitbucketIcon } from '../../assets/icons/bitBucket-icon.svg';
import { ReactComponent as GithubActions } from '../../assets/icons/github-actions-icon.svg';
import { ReactComponent as JenkinsIcon } from '../../assets/icons/jenkins.svg';
import { ReactComponent as AWSCodeBuildIcon } from '../../assets/icons/aws-codebuild.svg';
import { ReactComponent as GcpCloudFunctions } from '../../assets/icons/gcp-cloudFunctions.svg';
import { ReactComponent as GcpComputeEngine } from '../../assets/icons/gcp-computeEngine.svg';
import { ReactComponent as AwsEC2 } from '../../assets/icons/aws-ec2.svg';
import { ReactComponent as AwsCloudEcs } from '../../assets/icons/aws-ecs.svg';
import { ReactComponent as AwsEcr } from '../../assets/icons/aws-ecr.svg';
import { ReactComponent as GcpLogo } from '../../assets/icons/gcp-logo.svg';
import { ReactComponent as ServerlessIcon } from '../../assets/icons/serverless.svg';
import { ReactComponent as GenericIcon } from '../../assets/icons/generic-icon.svg';
import { ReactComponent as GoogleArtifactRegistry } from '../../assets/icons/GCP-Artifact-Registry-icon.svg';
import { ReactComponent as DockerHubIcon } from '../../assets/icons/dockerhub-icon.svg';
import { SiJfrog } from 'react-icons/si';

export const artifactsFilters = [
  {
    type: FilterTypeToFilter.ArtifactName,
    header: FilterType.artifactName,
    searchType: FilterTypeSearch.artifactName,
  },
  {
    type: FilterTypeToFilter.Apps,
    header: FilterType.apps,
    searchType: FilterTypeSearch.apps,
  },
  { type: FilterTypeToFilter.ArtifactTypes, header: FilterType.artifactsType },
  {
    type: FilterTypeToFilter.Cicd,
    header: FilterType.cicd,
  },
  { type: FilterTypeToFilter.Enviorment, header: FilterType.enviorment },
  {
    type: FilterTypeToFilter.ExecutionStatus,
    header: FilterType.executionStatus,
  },
  {
    type: FilterTypeToFilter.Cloud,
    header: FilterType.cloudDeployments,
  },
  {
    type: FilterTypeToFilter.Enviorment,
    header: FilterType.enviorment,
  },
  { type: FilterTypeToFilter.Category, header: FilterType.categories },
  { type: FilterTypeToFilter.IssueSeverities, header: FilterType.severity },
  { type: FilterTypeToFilter.RegistryType, header: FilterType.registryType },
  { type: FilterTypeToFilter.SourceType, header: FilterType.source },
  {
    type: FilterTypeToFilter.Version,
    header: FilterType.version,
    searchType: FilterTypeSearch.version,
  },
  {
    type: FilterTypeToFilter.User,
    header: FilterType.user,
    searchType: FilterTypeSearch.user,
  },
];

const artifactsIconsMap = new Map<ArtifactInfoTypes, IconType>([
  [ArtifactInfoTypes.DockerContainer, ContainerIcon],
  [ArtifactInfoTypes.Container, ContainerIcon],
  [ArtifactInfoTypes.Lambda, LambdaIcon],
  [ArtifactInfoTypes.NPM, NPMIcon],
  [ArtifactInfoTypes.Yarn, YarnIcon],
  [ArtifactInfoTypes.Serverless, ServerlessIcon],
]);

export const getArtifactIconType = (type: ArtifactInfoTypes) => {
  return artifactsIconsMap.get(type);
};

const scmIconsMap = new Map<CodeArtifactSCMTypes, IconType>([
  [CodeArtifactSCMTypes.GitLab, GitlabIcon],
  [CodeArtifactSCMTypes.Github, GithubIcon],
  [CodeArtifactSCMTypes.Bitbucketstash, BitbucketstashIcon],
  [CodeArtifactSCMTypes.Azure, AzureIcon],
  [CodeArtifactSCMTypes.AWSCodeBuild, AWSCodeBuildIcon],
  [CodeArtifactSCMTypes.Bitbucket, BitbucketIcon],
]);

export const getScmIconType = (scmType: CodeArtifactSCMTypes) => {
  return scmIconsMap.get(scmType);
};

const cicdSystemIconsMap = new Map<CICDSystems, IconType>([
  [CICDSystems.GithubActions, GithubActions],
  [CICDSystems.Gitlab, GitlabIcon],
  [CICDSystems.Jenkins, JenkinsIcon],
  [CICDSystems.Github, GithubIcon],
]);

export const getCicdSystemIconType = (cicdSystemType: CICDSystems) => {
  return cicdSystemIconsMap.get(cicdSystemType);
};

const cloudSubTypeIconMap = new Map<CloudSubType, IconType>([
  [CloudSubType.CloudFunction, GcpCloudFunctions],
  [CloudSubType.ComputeEngine, GcpComputeEngine],
  [CloudSubType.EC2, AwsEC2],
  [CloudSubType.ECS, AwsCloudEcs],
  [CloudSubType.Lambda, LambdaIcon],
]);

export const getCloudSubTypeIconType = (cloudSubType: CloudSubType) => {
  return cloudSubTypeIconMap.get(cloudSubType);
};

const registryTypeIconMap = new Map<RegistryTypes, IconType>([
  [RegistryTypes.AmazonECR, AwsEcr],
  [RegistryTypes.Lambda, LambdaIcon],
  [RegistryTypes.ECR, AwsEcr],
  [RegistryTypes.GCP, GcpLogo],
  [RegistryTypes.JFrog, SiJfrog],
  [RegistryTypes.Generic, GenericIcon],
  [RegistryTypes.GoogleArtifactRegistry, GoogleArtifactRegistry],
  [RegistryTypes.GitlabRegistry, GitlabIcon],
  [RegistryTypes.Container, GcpLogo],
  [RegistryTypes.DockerHub, DockerHubIcon],
]);

export const getRegistryIconType = (registryType: RegistryTypes) => {
  return registryTypeIconMap.get(registryType);
};

export const artifactsCategories = [
  { key: '', value: 'Git Posture' },
  { key: '', value: 'Code Security' },
  { key: '', value: 'Secret Scan' },
  { key: '', value: 'Open Source Security' },
  { key: '', value: 'SBOM' },
  { key: '', value: 'Infrastructure as Code Scan' },
  { key: '', value: 'CI/CD Posture' },
  { key: '', value: 'Security Tool Coverage' },
  { key: '', value: 'Container Security' },
  { key: '', value: 'Artifact Integrity' },
  { key: '', value: 'Cloud Security' },
];

export const sumSeverities = (severities: number[]) => {
  let total = 0;
  for (let i = 0; i < severities.length; i++) {
    total += severities[i];
  }
  return total;
};
